export enum LoadingStatus {
  waiting = <any>'waiting',
  loading = <any>'loading',
  complete = <any>'complete'
}
